/** Normalize tag slugs from API / forms. */
export const normalizeTagSlugs = (tags) => {
  if (!tags) return [];
  const list = Array.isArray(tags) ? tags : [tags];
  return [...new Set(
    list
      .map((tag) => String(tag || '').trim().toLowerCase())
      .filter(Boolean)
  )];
};

export const slugifyCatalogTagLabel = (label) =>
  String(label || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const tagsEqual = (left, right) => {
  const a = normalizeTagSlugs(left).sort();
  const b = normalizeTagSlugs(right).sort();
  if (a.length !== b.length) return false;
  return a.every((slug, index) => slug === b[index]);
};

export const catalogTagLabelMap = (catalogTags = []) => {
  const map = new Map();
  catalogTags.forEach((tag) => {
    const slug = String(tag?.slug || '').trim().toLowerCase();
    if (!slug) return;
    map.set(slug, tag.label || slug);
  });
  return map;
};

/** Fallback when catalog API is not deployed yet. */
export const DEFAULT_CATALOG_ADDON_TAGS = [
  { slug: 'food', label: 'Food', sort_order: 10, is_active: true },
  { slug: 'beverage', label: 'Beverage', sort_order: 20, is_active: true },
  { slug: 'equipment', label: 'Equipment', sort_order: 30, is_active: true },
  { slug: 'service', label: 'Service', sort_order: 40, is_active: true },
  { slug: 'decor', label: 'Decor', sort_order: 50, is_active: true },
];
